import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Box, Button, Typography } from '@mui/material';
import GppBadIcon from '@mui/icons-material/GppBad';

function RatesError(props) {
    const { t } = useTranslation()

    return (
        <Box minWidth={250}>
            <Box m={2} textAlign='center'>
                <Typography fontWeight='bold' variant='h5'>{t('headText', { keyPrefix: 'alert.error.rate' })}</Typography>
                <Typography fontWeight='bold'>{t('primaryText', { keyPrefix: 'alert.error.rate' })}</Typography>
                <Typography>{t('secondaryText', { keyPrefix: 'alert.error.rate' })}</Typography>
            </Box>

            <Box m={2}>
                <GppBadIcon sx={{ textAlign: 'center', width: '100%', fontSize: 100 }} color="error" />
            </Box>

            <Box m={2}>
                <Button
                    component={Link}
                    to={0}
                    fullWidth
                    variant="contained"
                >
                    {t('buttonReload', { keyPrefix: 'alert.error.rate' })}
                </Button>
            </Box>

        </Box>
    );
}

export default RatesError;